import React, {
    useState,
    useEffect,
    KeyboardEvent,
    ChangeEvent,
} from 'react';

import withTheme from 'ui-library/hocs/withTheme';
import uid from 'ui-library/utils/uid';
import './BuySellToggle.css';

interface BuySellToggleProps
    extends Omit<
        React.InputHTMLAttributes<HTMLInputElement>,
        'onChange' | 'value' | 'type'
    > {
    value?: boolean;
    disabled?: boolean;
    error?: boolean;
    onChange?: (checked: boolean) => void;
    showText?: boolean;
    className?: string;
    offText?: string;
    onText?: string;
}

const BuySellToggle: React.FC<BuySellToggleProps> = (props) => {
    const {
        value = false,
        disabled = false,
        error = false,
        onChange = () => {},
        showText = false,
        className = '',
        offText = 'Buy',
        onText = 'Sell',
        ...rest
    } = props;

    const toggleId = uid('toggle');

    const [tempChecked, setTempChecked] = useState<boolean>(false);

    const handleChange = (
        event: ChangeEvent<HTMLInputElement>
    ) => {
        const isChecked = event.target.checked;

        onChange(isChecked);
        setTempChecked(isChecked);
    };

    const onPressEnter = (
        event: KeyboardEvent<HTMLLabelElement>
    ) => {
        if (event.which === 13 || event.key === 'Enter') {
            onChange(!tempChecked);
            setTempChecked(!tempChecked);
        }
    };

    useEffect(() => {
        setTempChecked(value);
    }, [value]);

    return (
        <div
            className={`BuySellToggle ${
                error ? 'toggle-error' : ''
            } ${className}`}
        >
            <input
                {...rest}
                id={toggleId}
                className="switch switch-round"
                type="checkbox"
                onChange={handleChange}
                checked={tempChecked}
                disabled={disabled}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label
                role="switch"
                aria-checked={tempChecked}
                htmlFor={toggleId}
                onKeyPress={onPressEnter}
                tabIndex={disabled ? -1 : 0}
            >
                <div className="toggle-wrapper">
                    <div
                        className={
                            disabled && tempChecked
                                ? 'toggler-disabled'
                                : ''
                        }
                        style={{
                            color: tempChecked
                                ? '#2167AE'
                                : '#FFFFFF',
                        }}
                    >
                        {offText}
                    </div>

                    <div
                        className={
                            disabled && !tempChecked
                                ? 'toggler-disabled'
                                : ''
                        }
                        style={{
                            color: tempChecked
                                ? '#FFFFFF'
                                : '#2167AE',
                        }}
                    >
                        {onText}
                    </div>
                </div>
            </label>
        </div>
    );
};

export default withTheme(BuySellToggle);